import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTableFilterType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { GetTextPipe } from 'src/app/pipes';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { CacheItem, TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { AllLocations, AllSites, AllSubLocations } from 'src/models';

@Component({
  selector: 'aims-config-sub-locations',
  templateUrl: './config-sub-locations.component.html',
  styleUrls: [ './config-sub-locations.component.css'],
  providers: [GetTextPipe, MainGridService]
})
export class ConfigSubLocationsComponent implements OnInit {
  @Input() permissionNeeded: number;

  resources: Observable<any>
  locations = this.transferHttp.getSingle<Array<AllLocations>>('Facilities/GetLocations');
  locationsCache;  
  locationLookup;

  sites = this.transferHttp.getCache<Array<AllSites>>(CacheItem.sites);
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'subLocation', label: 'SubLocation Name', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.required]  },
    { key: 'locationId', label: 'Parent Location', type: AimsCommonTableHeaderType.DYNAMIC, 
      events: { filterAndSort: (element) => this.getTextPipe.transform(element.locationId, 'locationId', 'location', this.locationsCache) }
    },
    { key: 'siteId', label: 'Site', type: AimsCommonTableHeaderType.DYNAMIC, 
      events: { filterAndSort: (element) => this.getTextPipe.transform(element.siteId, 'siteId', 'siteName', this.sites) }
    }            
  ]

  addRowInitialObject: AllSubLocations;
  tablePermissions: Observable<AimsCommonTablePermissions>;

  constructor(
    private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>,
    private getTextPipe: GetTextPipe) {
      this.addRowInitialObject = new AllSubLocations();
      this.addRowInitialObject.active = true;
      this.resources = this.mainGridService.getAll('Facilities/GetSubLocations', 'Facilities/SaveSubLocation');

      this.locationLookup = this.locations.pipe(
        map(locArr => locArr.map(l => {
          return {
            siteName: this.getTextPipe.transform(l.siteId, 'siteId', 'siteName', this.sites),
            siteId: l.siteId,
            location: l.location,
            locationId: l.locationId
          }
        }))
      );
      
      this.locations.subscribe(data => 
        { 
          this.locationsCache = data; 
        }
      )     
  }

  ngOnInit(): void {
      this.resources = combineLatest([this.resources, this.locations]).pipe(
        map(([resourceData, locationData]) => {
          return resourceData.map(resource => {
            const location = locationData.find(loc => loc.locationId === resource.locationId);
            const siteId = location ? location.siteId : null;
            const siteName = this.sites.find(site => site.siteId === siteId)?.siteName;
            return {
              ...resource,
              siteId,
              locationId: location ? location.locationId : null,
              location: location ? location.location : null,
            };
          });
        })
      );     

    this.tablePermissions = this.permissions.getDataGridPerms$(this.permissionNeeded, { export: false, delete: false });
  }

  handleRowUpdate(update: TableRowUpdate): void {          
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe())
  }   

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe())
  }

  handleLookupChange(dataItem, element, control) {
    //patch values when one control affects another
    if (!dataItem) {
      dataItem = {} // We want to patch below with a null/undefined value
    }

    control.parent.patchValue(      
    {
      'locationId': dataItem.locationId,
      'siteId': dataItem.siteId
    });      
    
    element.locationId = dataItem.locationId;
    element.siteId = dataItem.siteId;
  }

  locationLookupColumns:AimsCommonTableHeader[] = [
    { key: 'siteName', label: 'Site', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'location', label: 'Location', type: AimsCommonTableHeaderType.STRING, filter: true }
  ];

}



